<template>
  <div class="mt-component-form">
    <vs-row class="my-4 header-flex">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="header-buttons">
        <!-- Desktop: 항목추가 + 선택삭제 -->
        <vs-button
          v-if="!isPrint"
          class="desktop-only"
          color="secondary"
          type="border"
          @click="handleAddRow"
          >항목추가</vs-button
        >
        <!-- PC/Mobile 공통: 선택삭제 -->
        <vs-button
          v-if="!isPrint"
          class="ml-4"
          color="secondary"
          :disabled="selectedItemsCount === 0"
          @click="handleRemoveRowConfirm"
          >선택삭제</vs-button
        >
      </div>
    </vs-row>

    <!-- 빈 목록 안내 메시지 -->
    <div v-if="targetList.length === 0 && !isPrint" class="empty-list-message">
      <div class="empty-content">
        <i class="feather icon-inbox empty-icon"></i>
        <p class="empty-text">항목을 추가해주세요</p>
        <vs-button
          color="primary"
          type="filled"
          @click="handleAddRow"
          class="empty-add-btn"
        >
          <i class="feather icon-plus mr-2"></i>
          첫 번째 항목 추가
        </vs-button>
      </div>
    </div>

    <!-- Desktop 테이블 레이아웃 -->
    <div class="desktop-layout">
      <div class="desktop-table-header">
        <div class="checkbox-col row-header__item">
          <vs-checkbox
            v-model="equipAllCheck"
            @change="changeAllCheck"
          ></vs-checkbox>
        </div>
        <div class="content-col row-header__item">점검대상</div>
        <div class="content-col row-header__item">소속명(부서명)/직급</div>
        <div class="content-col row-header__item">직책</div>
        <div class="content-col row-header__item">성명</div>
        <div class="content-col row-header__item">연락처</div>
        <div class="content-col-wide row-header__item">점검방법</div>
        <div class="content-col row-header__item">점검주기</div>
      </div>
      <!-- rows -->
             <div
         class="desktop-table-row"
         v-for="(rows, indexRows) in targetList"
         :key="indexRows"
       >
         <div class="checkbox-col none-border-center">
           <vs-checkbox v-if="!isPrint" v-model="rows.is_checked"></vs-checkbox>
         </div>
         <div class="content-col item-area">
           <vs-select
             v-if="!isPrint"
             class="w-full flex-1 p-1"
             autocomplete
             v-model="rows.target"
           >
             <vs-select-item text="건설공사 기간 연장" value="건설공사 기간 연장" />
             <vs-select-item text="도급전 정보 제공" value="도급전 정보 제공" />
             <vs-select-item text="반기별 점검" value="반기별 점검" />
             <vs-select-item text="보건교육" value="보건교육" />
             <vs-select-item text="비상대피 교육" value="비상대피 교육" />
             <vs-select-item text="비상대피 자체평가" value="비상대피 자체평가" />
             <vs-select-item text="비상대피 훈련" value="비상대피 훈련" />
             <vs-select-item text="비상연락/지원 체계도" value="비상연락/지원 체계도" />
             <vs-select-item text="비상연락망" value="비상연락망" />
             <vs-select-item text="비상조치계획 수립" value="비상조치계획 수립" />
             <vs-select-item text="사업장 경영방침" value="사업장 경영방침" />
             <vs-select-item text="산업재해조사" value="산업재해조사" />
             <vs-select-item text="설계변경 요청" value="설계변경 요청" />
             <vs-select-item text="수급인 산재예방 평가" value="수급인 산재예방 평가" />
             <vs-select-item text="순회점검" value="순회점검" />
             <vs-select-item text="시정 및 예방조치" value="시정 및 예방조치" />
             <vs-select-item text="아차사고" value="아차사고" />
             <vs-select-item text="안전교육" value="안전교육" />
             <vs-select-item text="안전보건관리 수행평가" value="안전보건관리 수행평가" />
             <vs-select-item text="안전보건 예산" value="안전보건 예산" />
             <vs-select-item text="안전보건 확보 의무" value="안전보건 확보 의무" />
             <vs-select-item text="안전보건대장 작성" value="안전보건대장 작성" />
             <vs-select-item text="안전보건협의체 구성" value="안전보건협의체 구성" />
             <vs-select-item text="위험성평가" value="위험성평가" />
             <vs-select-item text="유해위험요인 파악" value="유해위험요인 파악" />
             <vs-select-item text="작업계획서" value="작업계획서" />
             <vs-select-item text="작업중지제" value="작업중지제" />
             <vs-select-item text="작업허가서" value="작업허가서" />
             <vs-select-item text="장비점검" value="장비점검" />
             <vs-select-item text="재발방지계획서" value="재발방지계획서" />
             <vs-select-item text="중대재해 발생 조사" value="중대재해 발생 조사" />
             <vs-select-item text="기타" value="기타" />
           </vs-select>
           <span v-else class="print-input">{{ rows.target }}</span>
         </div>
         <div class="content-col item-area">
           <ml-input
             v-if="!isPrint"
             rows="1"
             v-model="rows.group"
             class="w-full flex-1 p-1"

           />
           <span v-else class="print-input">{{ rows.group }}</span>
         </div>
         <div class="content-col item-area">
           <vs-select
             v-if="!isPrint"
             class="w-full flex-1 p-1"
             autocomplete
             v-model="rows.type"
           >
             <vs-select-item text="안전보건총괄책임자" value="안전보건총괄책임자" />
             <vs-select-item text="안전보건책임자" value="안전보건책임자" />
             <vs-select-item text="안전보건조정자" value="안전보건조정자" />
             <vs-select-item text="관리감독자" value="관리감독자" />
             <vs-select-item text="안전관리자" value="안전관리자" />
             <vs-select-item text="보건관리자" value="보건관리자" />
             <vs-select-item text="산업보건의" value="산업보건의" />
             <vs-select-item text="현장관리자" value="현장관리자" />
             <vs-select-item text="안전담당자" value="안전담당자" />
             <vs-select-item text="보건담당자" value="보건담당자" />
             <vs-select-item text="담당자" value="담당자" />
           </vs-select>
           <span v-else class="print-input">{{ rows.type }}</span>
         </div>
         <div class="content-col item-area">
           <ml-input
             v-if="!isPrint"
             rows="1"
             v-model="rows.name"
             class="w-full flex-1 p-1"

           />
           <span v-else class="print-input">{{ rows.name }}</span>
         </div>
         <div class="content-col item-area">
           <ml-input
             v-if="!isPrint"
             rows="1"
             v-model="rows.phone"
             class="w-full flex-1 p-1"

           />
           <span v-else class="print-input">{{ rows.phone }}</span>
         </div>
         <div class="content-col-wide item-area">
           <ml-textarea
             v-if="!isPrint"
             rows="4"
             v-model="rows.note"
             class="w-full flex-1 px-1 my-1"

           />
           <span v-else class="print-textarea">{{ rows.note }}</span>
         </div>

         <div class="content-col item-area">
           <ml-input
             v-if="!isPrint"
             rows="1"
             v-model="rows.cycle"
             class="w-full flex-1 p-1"

           />
           <span v-else class="print-input">{{ rows.cycle }}</span>
         </div>
       </div>
    </div>

    <!-- Mobile 카드 레이아웃 -->
    <div class="mobile-layout">
      <!-- 모바일 전체 선택 헤더 (아이템이 있을 때만) -->
      <div
        class="mobile-header"
        v-if="!isPrint && targetList.length > 0"
        @click="toggleAllCheck"
      >
        <vs-checkbox :value="equipAllCheck" />
        <span class="mobile-header-text">전체 선택</span>
      </div>

      <!-- 모바일 카드형 아이템들 -->
      <div class="mobile-cards-container">
        <div
          v-for="(rows, indexRows) in targetList"
          :key="indexRows"
          class="mobile-card"
          :class="{ 'selected': rows.is_checked, 'print-mode': isPrint }"
        >
          <!-- 카드 헤더 (체크박스 + 인덱스 + 삭제 버튼) -->
          <div class="mobile-card-header" v-if="!isPrint">
            <div class="mobile-card-header-left">
              <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
              <span class="card-index">{{ indexRows + 1 }}번째 항목</span>
            </div>
            <vs-button
              class="mobile-delete-btn"
              color="danger"
              type="flat"
              size="small"
              @click="handleDeleteSingleItem(indexRows)"
            >
              삭제
            </vs-button>
          </div>
          <div class="mobile-card-header print-header" v-else>
            <span class="card-index">{{ indexRows + 1 }}번째 항목</span>
          </div>

          <!-- 카드 내용 -->
          <div class="mobile-card-content">
            <!-- 점검대상 -->
            <div class="mobile-field">
              <label class="mobile-field-label">점검대상</label>
              <div class="mobile-field-input">
                <vs-select
                  v-if="!isPrint"
                  class="w-full"
                  autocomplete
                  v-model="rows.target"
                >
                  <vs-select-item text="건설공사 기간 연장" value="건설공사 기간 연장" />
                  <vs-select-item text="도급전 정보 제공" value="도급전 정보 제공" />
                  <vs-select-item text="반기별 점검" value="반기별 점검" />
                  <vs-select-item text="보건교육" value="보건교육" />
                  <vs-select-item text="비상대피 교육" value="비상대피 교육" />
                  <vs-select-item text="비상대피 자체평가" value="비상대피 자체평가" />
                  <vs-select-item text="비상대피 훈련" value="비상대피 훈련" />
                  <vs-select-item text="비상연락/지원 체계도" value="비상연락/지원 체계도" />
                  <vs-select-item text="비상연락망" value="비상연락망" />
                  <vs-select-item text="비상조치계획 수립" value="비상조치계획 수립" />
                  <vs-select-item text="사업장 경영방침" value="사업장 경영방침" />
                  <vs-select-item text="산업재해조사" value="산업재해조사" />
                  <vs-select-item text="설계변경 요청" value="설계변경 요청" />
                  <vs-select-item text="수급인 산재예방 평가" value="수급인 산재예방 평가" />
                  <vs-select-item text="순회점검" value="순회점검" />
                  <vs-select-item text="시정 및 예방조치" value="시정 및 예방조치" />
                  <vs-select-item text="아차사고" value="아차사고" />
                  <vs-select-item text="안전교육" value="안전교육" />
                  <vs-select-item text="안전보건관리 수행평가" value="안전보건관리 수행평가" />
                  <vs-select-item text="안전보건 예산" value="안전보건 예산" />
                  <vs-select-item text="안전보건 확보 의무" value="안전보건 확보 의무" />
                  <vs-select-item text="안전보건대장 작성" value="안전보건대장 작성" />
                  <vs-select-item text="안전보건협의체 구성" value="안전보건협의체 구성" />
                  <vs-select-item text="위험성평가" value="위험성평가" />
                  <vs-select-item text="유해위험요인 파악" value="유해위험요인 파악" />
                  <vs-select-item text="작업계획서" value="작업계획서" />
                  <vs-select-item text="작업중지제" value="작업중지제" />
                  <vs-select-item text="작업허가서" value="작업허가서" />
                  <vs-select-item text="장비점검" value="장비점검" />
                  <vs-select-item text="재발방지계획서" value="재발방지계획서" />
                  <vs-select-item text="중대재해 발생 조사" value="중대재해 발생 조사" />
                  <vs-select-item text="기타" value="기타" />
                </vs-select>
                <span v-else class="mobile-print-value">{{ rows.target }}</span>
              </div>
            </div>

            <!-- 소속명/직급 -->
            <div class="mobile-field">
              <label class="mobile-field-label">소속명(부서명)/직급</label>
              <div class="mobile-field-input">
                <ml-input
                  v-if="!isPrint"
                  rows="1"
                  v-model="rows.group"
                  class="w-full"
                />
                <span v-else class="mobile-print-value">{{ rows.group }}</span>
              </div>
            </div>

            <!-- 직책 -->
            <div class="mobile-field">
              <label class="mobile-field-label">직책</label>
              <div class="mobile-field-input">
                <vs-select
                  v-if="!isPrint"
                  class="w-full"
                  autocomplete
                  v-model="rows.type"
                >
                  <vs-select-item text="안전보건총괄책임자" value="안전보건총괄책임자" />
                  <vs-select-item text="안전보건책임자" value="안전보건책임자" />
                  <vs-select-item text="안전보건조정자" value="안전보건조정자" />
                  <vs-select-item text="관리감독자" value="관리감독자" />
                  <vs-select-item text="안전관리자" value="안전관리자" />
                  <vs-select-item text="보건관리자" value="보건관리자" />
                  <vs-select-item text="산업보건의" value="산업보건의" />
                  <vs-select-item text="현장관리자" value="현장관리자" />
                  <vs-select-item text="안전담당자" value="안전담당자" />
                  <vs-select-item text="보건담당자" value="보건담당자" />
                  <vs-select-item text="담당자" value="담당자" />
                </vs-select>
                <span v-else class="mobile-print-value">{{ rows.type }}</span>
              </div>
            </div>

            <!-- 성명과 연락처 - 한 줄로 배치 -->
            <div class="mobile-field-row">
              <div class="mobile-field mobile-field-half">
                <label class="mobile-field-label">성명</label>
                <div class="mobile-field-input">
                  <ml-input
                    v-if="!isPrint"
                    rows="1"
                    v-model="rows.name"
                    class="w-full"
                  />
                  <span v-else class="mobile-print-value">{{ rows.name }}</span>
                </div>
              </div>
              <div class="mobile-field mobile-field-half">
                <label class="mobile-field-label">연락처</label>
                <div class="mobile-field-input">
                  <ml-input
                    v-if="!isPrint"
                    rows="1"
                    v-model="rows.phone"
                    class="w-full"
                  />
                  <span v-else class="mobile-print-value">{{ rows.phone }}</span>
                </div>
              </div>
            </div>

            <!-- 점검방법 -->
            <div class="mobile-field">
              <label class="mobile-field-label">점검방법</label>
              <div class="mobile-field-input">
                <ml-textarea
                  v-if="!isPrint"
                  rows="3"
                  v-model="rows.note"
                  class="w-full"
                  placeholder="점검방법을 입력하세요"
                />
                <span v-else class="mobile-print-value mobile-print-textarea">{{ rows.note }}</span>
              </div>
            </div>

            <!-- 점검주기 -->
            <div class="mobile-field">
              <label class="mobile-field-label">점검주기</label>
              <div class="mobile-field-input">
                <ml-input
                  v-if="!isPrint"
                  rows="1"
                  v-model="rows.cycle"
                  class="w-full"
                />
                <span v-else class="mobile-print-value">{{ rows.cycle }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 하단 항목 추가 버튼 (아이템이 있을 때만) -->
      <div class="mobile-add-button-container" v-if="!isPrint && targetList.length > 0">
        <vs-button
          class="mobile-add-btn"
          color="primary"
          type="filled"
          size="large"
          @click="handleAddRow"
        >
          <i class="feather icon-plus mr-2"></i>
          항목 추가
        </vs-button>
      </div>
    </div>

    <!-- 삭제 확인 팝업 -->
    <vs-popup class="popup-example" title="삭제 확인" :active.sync="showDeleteConfirm">
      <div class="popup-content">
        <p class="delete-message">{{ deleteMessage }}</p>
        <div class="popup-buttons">
          <vs-button
            color="danger"
            type="filled"
            @click="confirmDelete"
          >
            삭제
          </vs-button>
          <vs-button
            color="dark"
            type="flat"
            @click="cancelDelete"
          >
            취소
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'TableInspectionGroup',
  props: {
    title: String,
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value && value.length > 0) {
          this.targetList = value
        }
      },
    },
  },
  methods: {
    // 항목추가
    handleAddRow () {
      this.targetList.push({
        is_checked: this.equipAllCheck,
        target: '',
        group: '',
        type: '',
        name: '',
        phone: '',
        note: '',
        cycle: '',
      })
      this.updateList()
    },
    // 선택삭제 확인
    handleRemoveRowConfirm () {
      const selectedCount = this.targetList.filter(item => item.is_checked).length
      if (selectedCount === 0) {
        this.$vs.notify({
          title: '알림',
          text: '삭제할 항목을 선택해주세요.',
          color: 'warning'
        })
        return
      }

      this.deleteMessage = `선택된 ${selectedCount}개의 항목을 삭제하시겠습니까?`
      this.deleteAction = 'batch'
      this.showDeleteConfirm = true
    },
    // 개별 항목 삭제 확인
    handleDeleteSingleItem (index) {
      this.deleteMessage = `${index + 1}번째 항목을 삭제하시겠습니까?`
      this.deleteAction = 'single'
      this.deleteIndex = index
      this.showDeleteConfirm = true
    },
    // 삭제 확인
    confirmDelete () {
      if (this.deleteAction === 'batch') {
        this.handleRemoveRow()
      } else if (this.deleteAction === 'single') {
        this.handleRemoveSingleRow()
      }
      this.showDeleteConfirm = false
    },
    // 삭제 취소
    cancelDelete () {
      this.showDeleteConfirm = false
      this.deleteAction = null
      this.deleteIndex = null
      this.deleteMessage = ''
    },
    // 선택삭제 실행
    handleRemoveRow () {
      for (let i = 0; i < this.targetList.length; i++) {
        if (this.targetList[i].is_checked) {
          this.targetList.splice(i, 1)
          i--
        }
      }

      this.equipAllCheck = false
      this.updateList()

      this.$vs.notify({
        title: '삭제 완료',
        text: '선택된 항목이 삭제되었습니다.',
        color: 'success'
      })
    },
    // 개별 항목 삭제 실행
    handleRemoveSingleRow () {
      this.targetList.splice(this.deleteIndex, 1)
      this.updateList()

      this.$vs.notify({
        title: '삭제 완료',
        text: '항목이 삭제되었습니다.',
        color: 'success'
      })
    },
    // 일괄 체크
    changeAllCheck () {
      for (const data of this.targetList) {
        data.is_checked = this.equipAllCheck
      }
    },
    // 전체 선택 토글 (모바일 헤더 클릭 시)
    toggleAllCheck () {
      this.equipAllCheck = !this.equipAllCheck
      this.changeAllCheck()
    },
    // 체크박스 직접 클릭 처리
    handleCheckboxClick () {
      // v-model에 의해 equipAllCheck는 이미 변경된 상태
      this.changeAllCheck()
    },
    // update
    updateList () {
      this.$emit('updateList', this.targetList)
    },
  },
  computed: {
    selectedItemsCount () {
      return this.targetList.filter(item => item.is_checked).length
    },
  },
  data () {
    return {
      equipAllCheck: false,
      targetList: [],
      showDeleteConfirm: false,
      deleteMessage: '',
      deleteAction: null,
      deleteIndex: null,
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
$mobile-breakpoint: 768px;
$mobile-card-bg: #ffffff;
$mobile-card-border: 1px solid #e8e8e8;
$mobile-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
$mobile-selected-bg: #f0f9ff;
$mobile-selected-border: 1px solid #3b82f6;

.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons {
  display: flex;
  align-items: center;
}

.desktop-only {
  display: inline-flex;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  /*margin-left: 15px;*/
  margin: 0;
}

/* 반응형 레이아웃 제어 */
.desktop-layout {
  display: block;
}
.mobile-layout {
  display: none;
}

/* 빈 목록 안내 메시지 */
.empty-list-message {
  padding: 60px 20px;
  text-align: center;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  margin-bottom: 20px;
}

.empty-content {
  max-width: 300px;
  margin: 0 auto;
}

.empty-icon {
  font-size: 48px;
  color: #94a3b8;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 24px;
  font-weight: 500;
}

.empty-add-btn {
  min-height: 44px;
  padding: 12px 24px;
  font-weight: 600;

  .feather {
    font-size: 16px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }

  /* 모바일에서 항목추가 버튼 숨김 */
  .desktop-only {
    display: none !important;
  }

  /* 모바일 헤더 최적화 */
  .header-flex {
    .header-buttons {
      .vs-button {
        min-height: 40px;
        font-size: 14px;
        padding: 8px 16px;
      }
    }
  }

  /* 빈 목록 메시지 모바일 최적화 */
  .empty-list-message {
    padding: 40px 16px;
    margin-bottom: 16px;
  }

  .empty-icon {
    font-size: 40px;
  }

  .empty-text {
    font-size: 15px;
  }
}

/* Desktop Table Styles */
.desktop-table-header,
.desktop-table-row {
  display: grid;
  grid-template-columns: 60px 1fr 1.2fr 1.1fr 0.8fr 1fr 1.5fr 0.9fr;
  border-bottom: $border;
}

.desktop-table-header {
  background-color: $bg;
}

.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}

.checkbox-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.content-col {
  min-width: 120px;
}

.content-col-wide {
  min-width: 180px;
}
.row-header__item {
  border-top: $border;
  border-bottom: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}

.desktop-table-row {
  border-bottom: $border;
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Mobile Styles */
.mobile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: $bg;
  border: $border;
  border-radius: 8px;
  margin-bottom: 15px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #f1f5f9;
    border-color: #94a3b8;
  }

  &:active {
    transform: scale(0.98);
  }

  .mobile-header-text {
    font-weight: 500;
    font-size: 16px;
    color: #374151;
    flex: 1;
  }

  .vs-checkbox {
    transform: scale(1.2); // 터치하기 쉽게 확대
    pointer-events: none; // 체크박스 직접 클릭 방지
  }
}

.mobile-cards-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-card {
  background: $mobile-card-bg;
  border: $mobile-card-border;
  border-radius: 12px;
  box-shadow: $mobile-card-shadow;
  overflow: hidden;
  transition: all 0.3s ease;

  &.selected {
    background: $mobile-selected-bg;
    border: $mobile-selected-border;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }

  &.print-mode {
    box-shadow: none;
    border: $border;
    margin-bottom: 10px;
  }
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;

  &.print-header {
    background: $bg;
    justify-content: center;
  }

  .mobile-card-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .card-index {
    font-weight: 600;
    font-size: 16px;
    color: #1e293b;
  }

  .vs-checkbox {
    transform: scale(1.2);
  }

  .mobile-delete-btn {
    min-height: 32px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 6px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(220, 38, 38, 0.3);
    }
  }
}

.mobile-card-content {
  padding: 20px;
}

.mobile-field {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.mobile-field-row {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.mobile-field-half {
  flex: 1;
  margin-bottom: 0;
}

.mobile-field-label {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  line-height: 1.4;
}

.mobile-field-input {
  .vs-select,
  .vs-input,
  .vs-textarea {
    min-height: 44px; // 터치 친화적 크기

    .vs-select__input,
    .vs-input__input,
    .vs-textarea__input {
      font-size: 16px; // iOS 줌 방지
      padding: 12px 16px;
    }
  }

  .vs-select {
    .vs-select__input {
      border-radius: 8px;
      border: 1px solid #d1d5db;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }

  .vs-textarea {
    .vs-textarea__input {
      border-radius: 8px;
      border: 1px solid #d1d5db;
      min-height: 80px;
      resize: vertical;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }
}

.mobile-print-value {
  display: block;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  min-height: 20px;

  &.mobile-print-textarea {
    min-height: 60px;
    white-space: pre-wrap;
    line-height: 1.5;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .desktop-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }

  /* 인쇄 시 체크박스 컬럼 숨김 */
  .desktop-table-header,
  .desktop-table-row {
    grid-template-columns: 1fr 1.2fr 1.1fr 0.8fr 1fr 1.5fr 0.9fr !important;
  }

  /* 체크박스 컬럼 완전히 숨김 */
  .checkbox-col {
    display: none !important;
  }

  /* 테이블 인쇄 최적화 */
  .desktop-table-header,
  .desktop-table-row {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  /* 첫 번째 행이 아닌 경우 적절한 간격 유지 */
  .desktop-table-row + .desktop-table-row {
    break-before: auto;
    page-break-before: auto;
  }
}

/* 모바일 하단 항목 추가 버튼 */
.mobile-add-button-container {
  margin-top: 20px;
  padding: 0 5px;
}

.mobile-add-btn {
  width: 100%;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .feather {
    font-size: 18px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3);
  }
}

/* 삭제 확인 팝업 스타일 */
.popup-content {
  padding: 20px;
  text-align: center;
}

.delete-message {
  font-size: 16px;
  color: #374151;
  margin-bottom: 25px;
  line-height: 1.5;
}

.popup-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;

  .vs-button {
    min-width: 100px;
    min-height: 40px;
    font-weight: 600;
  }
}

/* 작은 모바일 화면 최적화 */
@media (max-width: 480px) {
  .mobile-card-content {
    padding: 15px;
  }

  .mobile-field-row {
    flex-direction: column;
    gap: 0;

    .mobile-field-half {
      margin-bottom: 15px;
    }
  }

  .mobile-header {
    padding: 12px;
  }

  .mobile-card-header {
    padding: 12px 15px;

    .mobile-card-header-left {
      .card-index {
        font-size: 14px;
      }
    }

    .mobile-delete-btn {
      min-height: 28px;
      padding: 6px 10px;
      font-size: 11px;
    }
  }

  .mobile-add-btn {
    min-height: 48px;
    font-size: 15px;

    .feather {
      font-size: 16px;
    }
  }

  .popup-buttons {
    flex-direction: column;
    gap: 10px;

    .vs-button {
      width: 100%;
    }
  }
}
</style>
